import { render, staticRenderFns } from "./CategoriaEmpresaField.vue?vue&type=template&id=ae566a40&"
import script from "./CategoriaEmpresaField.vue?vue&type=script&lang=js&"
export * from "./CategoriaEmpresaField.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaEmpresaField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports